<template>
  <div class="create-courier bg-white">
    <div class="flex justify-between items-start shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r">
        <div class="p-6 shadow-border-b mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
          <p class="font-bold text-lg mb-6">Info Kurir</p>
          <div class="mb-6 w-44">
            <TextField type="text" label="ID" :disabled="true" />
          </div>
          <div class="mb-6">
            <TextField type="text" label="Nama" v-model="payloads.name" placeholder="Masukan nama kurir" />
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jenis Kelamin</label>
            <CustomSelect :options="genderList" v-model="selectedGender" :default="selectedGender" optionLabel="label" placeholder="Pilih jenis kelamin" />
          </div>
          <div class="mb-6">
            <TextField type="text" label="No Handphone" v-model="payloads.phone_number" placeholder="Masukan no handphone" />
          </div>
          <div class="mb-6">
            <TextField type="text" label="Email" v-model="payloads.email" placeholder="Masukan email" />
          </div>
          <div class="mb-6 text-left relative">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block"><span class="text-system-error">*</span>Kota / Kecamatan / Kode POS Pengirim</label>
            <div class="relative">
              <TextField withIcon type="text" @input="searchCity($event)" v-model="destinationSearch" placeholder="Kota / Kecamatan / Kode POS Pengirim" />
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                <Search />
              </div>
              <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching" />
              <transition name="fade" mode="out-in">
                <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion">
                  <ul v-if="cities" class="max-h-40 overflow-y-scroll">
                    <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300" v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city)">
                      {{ city.village }}, {{ city.area_display }}
                    </li>
                  </ul>
                  <div class="py-4 text-center" v-else>Maaf data tidak ditemukan!</div>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class="p-6 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
          <p class="font-bold text-lg mb-6">KTP & SIM</p>
          <div class="mb-6">
            <TextField type="text" v-model="payloads.id_card_number" label="No KTP" placeholder="Masukan no KTP" />
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe SIM</label>
            <CustomSelect :options="driverLicenseTypes" optionLabel="driver_license_name" v-model="selectedLicenseType" placeholder="Pilih tipe SIM" />
          </div>
          <div class="mb-6">
            <TextField type="text" v-model="payloads.driver_license_number" label="No SIM" placeholder="Masukan no SIM" />
          </div>
        </div>
      </div>
      <div class="flex-1 p-6 mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Informasi Bank</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Bank</label>
          <CustomSelect :options="bankCodes" v-model="selectedBank" :default="selectedBank" placeholder="Pilih nama bank" optionLabel="name" />
        </div>
        <div class="mb-6">
          <TextField type="text" v-model="payloads.bank_account" label="No Rekening" placeholder="Masukan no rekening" />
        </div>
        <div class="mb-6">
          <TextField type="text" v-model="payloads.bank_account_holder" label="Pemilik Rekening" placeholder="Masukan nama pemilik rekening" />
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end mdmax:justify-center">
      <Button buttonText="Simpan" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "form" */ '@/components/Forms/TextField'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search')
  },
  data: () => ({
    typeList: ['A', 'B1', 'B2', 'C'],
    selectedType: null,
    selectedPartner: null,
    visiblePartner: false,
    selectedCity: null,
    selectedBank: null,
    selectedGender: null,
    selectedLicenseType: null,
    genderList: [
      {
        label: 'Laki-Laki',
        value: 'M'
      },
      {
        label: 'Perempuan',
        value: 'F'
      }
    ],
    payloads: {
      email: null,
      phone_number: null,
      name: null,
      gender: null,
      is_published: false,
      id_card_number: null,
      driver_license_type: null,
      driver_license_number: null,
      bank_account_holder: null,
      bank_code: null,
      bank_account: null,
      area_code: null
    },
    debounce: null,
    destination: '',
    destinationSearch: '',
    cityKeyword: null,
    visibleSuggestion: false,
    isSearching: false
  }),
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('master', ['bankCodes', 'cities', 'driverLicenseTypes'])
  },
  created() {
    this.getCityList()
    this.getBankCodeList()
    this.getDriverLicenseList()
  },
  watch: {
    selectedGender(val) {
      if (val) {
        this.payloads.gender = val.value
      }
    },
    selectedCity(val) {
      if (val) {
        this.payloads.area_code = this.selectedCity.code
      }
    },
    selectedBank(val) {
      if (val) {
        this.payloads.bank_code = this.selectedBank.code
      }
    },
    selectedLicenseType(val) {
      if (val) {
        this.payloads.driver_license_type = val.driver_license_type
      }
    }
  },
  methods: {
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading']),
    ...mapActions('master', ['getBankCodes', 'getCities', 'getDriverLicenseTypes']),
    ...mapActions('courier', ['createCourier']),
    searchCity(value) {
      this.cityKeyword = null
      if (value) this.isSearching = true
      this.visibleSuggestion = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (value) {
          this.cityKeyword = value
          this.getCities({
            params: {
              page: 1,
              per_page: 1000,
              search_keyword: this.cityKeyword
            }
          }).then(() => {
            this.visibleSuggestion = true
            this.isSearching = false
          })
        }
      }, 200)
    },
    selectCity(data) {
      this.payloads.area_code = data.code
      this.destinationSearch = `${data.village}, ${data.area_display}`
      this.visibleSuggestion = false
    },
    submit() {
      this.showLoading()
      this.createCourier({
        payloads: this.payloads
      }).then(() => {
        this.hideLoading()
        const promise = new Promise((resolve, reject) => {
          this.setToast({
            options: { type: 'success', duration: 3000, primaryText: 'Penambahan Armada Berhasil', secondaryText: 'Data telah kami simpan, silahkan tutup halaman ini' }
          })
          resolve()
        })
        promise.then(() => {
          this.$router.push('/kurir')
        })
      })
    },
    getCityList() {
      this.getCities({
        params: {
          page: 1,
          per_page: 1000,
          search_keyword: ''
        }
      })
    },
    getBankCodeList() {
      this.getBankCodes()
    },
    getDriverLicenseList() {
      this.getDriverLicenseTypes()
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
  &::v-deep .vs__dropdown-toggle {
    padding: 0;
    border-radius: 0.5rem;
    height: 50px;
  }
  &::v-deep .vs__actions {
    padding: 0px 12px 0 3px;
  }
  &::v-deep .vs__open-indicator {
    fill: #333;
  }
  &::v-deep .vs__selected {
    margin: 0;
    padding: 0 0.75rem;
  }
  &::v-deep .vs__selected-options {
    padding: 0;
  }
  &::v-deep .v-select {
    z-index: 0;
  }
}
</style>
